import React from 'react'
import styled from 'styled-components'

import { fontSizeResponsive } from '../../../theme/mixins'

const DeleteModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 15px;
`

const DeleteModalHeader = styled.div`
  ${fontSizeResponsive(32)};
  font-weight: bold;
  font-family: 'Asap Condensed';
  color: #212121;
  text-align: center;
`

const DeleteModalSubHeader = styled.div`
  ${fontSizeResponsive(20)};
  font-weight: normal;
  margin-top: 20px;
  font-family: 'Asap Condensed';
  color: #212121;
  text-align: center;
`
const ButtonContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 35px;
`

const Bold = styled.span`
  font-weight: bold;
`

const Removemealbutton = styled.button`
  background-color: ${(props) =>
    props.backgroundColor ? props.backgroundColor : 'transparent'};
  border: ${(props) => (props.border ? '1px solid rgba(0,0,0,0.2)' : 'none')};
  border-radius: 6px;
  padding: 10px 30px;
  width: 150px;
  margin: 0 10px;
  font-family: 'Asap Condensed';
  font-weight: bold;
  ${fontSizeResponsive(23)};
  text-align: center;
  color: ${(props) => (props.color ? props.color : 'inherit')};
`

const DeleteModal = ({
  modalClose,
  removeMeal,
  deleteItemName,
  removeElement,
}) => {
  return (
    <DeleteModalContainer>
      <DeleteModalHeader>Usuń posiłek</DeleteModalHeader>
      <DeleteModalSubHeader>
        Czy jesteś pewny, że chcesz usunąć wybrany posiłek{' '}
        <Bold>({deleteItemName})</Bold> ?
      </DeleteModalSubHeader>
      <ButtonContainer>
        <Removemealbutton
          color={'white'}
          backgroundColor={'rgb(187,33,36)'}
          onClick={removeElement}
        >
          Tak
        </Removemealbutton>
        <Removemealbutton onClick={() => modalClose()} border>
          Anuluj
        </Removemealbutton>
      </ButtonContainer>
    </DeleteModalContainer>
  )
}
export default DeleteModal
